import React, { memo } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>{t('home.title')}</h1>
        <p style={styles.heroSubtitle}>{t('home.subtitle')}</p>
      </section>

      {/* Main Content */}
      <section style={styles.content}>
        <div style={styles.welcomeText}>
          <p style={styles.paragraph}>
            {t('home.welcomeP1')}
          </p>
          <p style={styles.paragraph}>
            {t('home.welcomeP2')}
          </p>
        </div>

        {/* Encyclopedia Credit Section */}
        <div style={styles.creditSection}>
          <h2 style={styles.creditTitle}>{t('home.creditTitle')}</h2>
          <div style={styles.creditBox}>
            <p style={styles.creditText}>
              {t('home.creditText1')}<br/> 
              {t('home.creditText2')} <strong>{t('home.creditBookTitle')}</strong>.
            </p>
            <p style={styles.creditText}>
              {t('home.creditCopyright')}<br/>
              {t('home.creditPhotos')}<br/>
              ISBN 80-85206-28-5
            </p>
            
            <div style={styles.quotebox}>
              <h3 style={styles.quoteTitle}>{t('home.creditPrefaceTitle')}</h3>
              <blockquote style={styles.quote}>
                <p style={styles.quoteParagraph}>
                  {t('home.creditQuoteP1')}
                </p>
                <p style={styles.quoteParagraph}>
                  {t('home.creditQuoteP2')}
                </p>
                <p style={styles.quoteParagraph}>
                  {t('home.creditQuoteP3')}
                </p>
              </blockquote>
            </div>
          </div>
        </div>

        {/* Navigation Hint */}
        <div style={styles.hint}>
          <p style={styles.hintText}>
            {t('home.navigationHint')}
          </p>
        </div>
      </section>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
  },
  hero: {
    textAlign: 'center' as const,
    padding: '40px 20px',
    marginBottom: '30px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '12px',
    color: 'white',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  heroTitle: {
    fontSize: '2.5rem',
    margin: '0 0 15px 0',
    fontWeight: 'bold' as const,
    textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    margin: 0,
    opacity: 0.95,
  },
  content: {
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(233, 236, 239, 0.6)',
    borderRadius: '8px',
    padding: '30px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  },
  welcomeText: {
    marginBottom: '40px',
  },
  paragraph: {
    fontSize: '1.1rem',
    lineHeight: 1.8,
    color: '#333',
    marginBottom: '20px',
    textAlign: 'justify' as const,
  },
  creditSection: {
    marginTop: '40px',
    paddingTop: '30px',
    borderTop: '2px solid #e9ecef',
  },
  creditTitle: {
    fontSize: '1.5rem',
    color: '#2c3e50',
    marginBottom: '20px',
    textAlign: 'center' as const,
  },
  creditBox: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '8px',
    border: '1px solid #dee2e6',
  },
  creditText: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#495057',
    marginBottom: '15px',
  },
  quotebox: {
    marginTop: '25px',
    paddingTop: '20px',
    borderTop: '1px solid #dee2e6',
  },
  quoteTitle: {
    fontSize: '1.1rem',
    color: '#495057',
    marginBottom: '15px',
    fontWeight: 'bold' as const,
  },
  quote: {
    margin: '0',
    padding: '20px',
    backgroundColor: 'white',
    borderLeft: '4px solid #667eea',
    borderRadius: '4px',
    fontStyle: 'italic' as const,
  },
  quoteParagraph: {
    fontSize: '0.95rem',
    lineHeight: 1.7,
    color: '#6c757d',
    marginBottom: '15px',
  },
  hint: {
    marginTop: '40px',
    padding: '20px',
    backgroundColor: '#e7f3ff',
    borderRadius: '8px',
    border: '1px solid #b8daff',
    textAlign: 'center' as const,
  },
  hintText: {
    fontSize: '1.1rem',
    color: '#004085',
    margin: 0,
    fontWeight: '500' as const,
  },
};

export default memo(HomePage);
